import axios from 'axios'
import React, { useEffect } from 'react'

function Logout ({history}) {
  useEffect(() => {
    axios.post('auth/logout')
    .then(res => {
      localStorage.removeItem("user")
      localStorage.removeItem("two_factor")

      history.push("/")
    })
    .catch(err => console.log(err))
  } , [])
  return (null)
}

export default Logout

